import React, { Component } from "react";
import { Spin, Radio, Space, message } from "antd";
import Bridge from "../../utils/Bridge";

export default class FamilyHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      positive_family_history: "",
      do_you_have_first_degree_biological_family_member: "",
      relationship_list: [
        {
          id: 1,
          relation: "",
          disease: "",
          is_genetic_testing_done: "",
          age: "",
        },
      ],
      loading: false,
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (
                item.field ==
                "Do You Have A Positive Family History For ALS Or Any Other Neurodegenerative Disease (Frontotemporal Dementia, Parkinson’s Disease, Alzheimer’s Disease)?"
              ) {
                this.setState({ positive_family_history: item.value });
              }
              if (
                item.field ==
                "Do you have a first degree biological family member who had or currently has ALS or FTD?"
              ) {
                this.setState({
                  do_you_have_first_degree_biological_family_member: item.value,
                });
              }
              if (
                item.field ==
                "Please indicate the relationship (mother, father, sibling, etc.), the disease, and the approximate age of onset of disease symptoms:"
              ) {
                this.setState({
                  relationship_list: item.value
                    ? JSON.parse(item.value)
                    : [
                        {
                          id: 1,
                          relation: "",
                          is_genetic_testing_done: "",
                          disease: "",
                          age: "",
                        },
                      ],
                });
              }
            }
          }
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  add_new_relation = () => {
    let arr = this.state.relationship_list;
    const randomInteger = this.getRandomInt(1, 2000);
    let obj = {
      id: randomInteger,
      relation: "",
      is_genetic_testing_done: "",
      disease: "",
      age: "",
    };
    arr.push(obj);
    this.setState({ relationship_list: arr });
  };
  remove_relation = (id) => {
    let arr = this.state.relationship_list;
    let tempArr = [];
    for (let single of arr) {
      if (single.id != id) {
        tempArr.push(single);
      }
    }
    this.setState({ relationship_list: tempArr });
  };
  update_relation = (event, item, field) => {
    let arr = this.state.relationship_list;
    let tempArr = [];
    for (let single of arr) {
      if (single.id == item.id) {
        if (field == "relation") {
          single.relation = event.target.value;
        }
        if (field == "disease") {
          single.disease = event.target.value;
        }
        if (field == "age") {
          single.age = event.target.value;
        }
        if (field == "is_genetic_testing_done") {
          single.is_genetic_testing_done = event.target.value;
        }
      }
      tempArr.push(single);
    }
    this.setState({ relationship_list: tempArr });
  };
  save = () => {
    if (!this.state.positive_family_history) {
      message.warning("Please select value of positive family history");
      return;
    }
    if (!this.state.do_you_have_first_degree_biological_family_member) {
      message.warning(
        "Please select value of 'Do you have a first degree biological family member who had or currently has ALS or FTD?' field"
      );
      return;
    }
    if (this.state.do_you_have_first_degree_biological_family_member == "Yes") {
      if (this.state.relationship_list.length === 0) {
        message.warning("Please add relation details");
        return;
      }
      if (this.state.relationship_list.length > 0) {
        let list = this.state.relationship_list;
        for (let item of list) {
          if (!item.relation) {
            message.warning("Please enter Relation Name");
            return;
          }
          if (!item.disease) {
            message.warning("Please enter Disease.");
            return;
          }
          if (!item.age) {
            message.warning("Please enter age.");
            return;
          }
          if (item.age > 100 || item.age < 18) {
            message.warning("Please enter valid age.");
            return;
          }
        }
      }
    }
    let questions = [
      {
        parent_field:
          "Do You Have A Positive Family History For ALS Or Any Other Neurodegenerative Disease (Frontotemporal Dementia, Parkinson’s Disease, Alzheimer’s Disease)?",
        field:
          "Do You Have A Positive Family History For ALS Or Any Other Neurodegenerative Disease (Frontotemporal Dementia, Parkinson’s Disease, Alzheimer’s Disease)?",
        value: this.state.positive_family_history,
      },
      {
        parent_field:
          "Do you have a first degree biological family member who had or currently has ALS or FTD?",
        field:
          "Do you have a first degree biological family member who had or currently has ALS or FTD?",
        value: this.state.do_you_have_first_degree_biological_family_member,
      },
      {
        parent_field:
          "Please indicate the relationship (mother, father, sibling, etc.), the disease, and the approximate age of onset of disease symptoms:",
        field:
          "Please indicate the relationship (mother, father, sibling, etc.), the disease, and the approximate age of onset of disease symptoms:",
        value: JSON.stringify(this.state.relationship_list),
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "6",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(7);
                // setTimeout(() => {
                //   window.location.assign("/dashboard");
                // }, 3000);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <div>
        <div className="header">
          <h3>FAMILY HISTORY OF NEURODEGENERATIVE DISEASE</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="mb-2">
                Do You Have A Positive Family History For ALS Or Any Other
                Neurodegenerative Disease (Frontotemporal Dementia, Parkinson’s
                Disease, Alzheimer’s Disease)?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(event) =>
                  this.setState({ positive_family_history: event.target.value })
                }
                value={this.state.positive_family_history}
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="mb-2">
                Do you have a first degree biological family member who had or
                currently has ALS or FTD? <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(event) =>
                  this.setState({
                    do_you_have_first_degree_biological_family_member:
                      event.target.value,
                    relationship_list: [],
                  })
                }
                value={
                  this.state.do_you_have_first_degree_biological_family_member
                }
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
            </div>
            {this.state.do_you_have_first_degree_biological_family_member ==
              "Yes" && (
              <div className="form-group">
                <div className="d-flex justify-content-between col-lg-9">
                  <label className="mb-2 input-heading">
                    Please indicate the relationship (mother, father, sibling,
                    etc.), the disease, and the approximate age of onset of
                    disease symptoms:
                    <span className="text-danger">*</span>
                  </label>
                  &nbsp;&nbsp;&nbsp;
                  <button
                    className="add_row_button"
                    onClick={() => this.add_new_relation()}
                  >
                    {" "}
                    <box-icon name="plus-circle" color="#fff"></box-icon>{" "}
                    &nbsp;&nbsp;Add{" "}
                  </button>
                </div>
                <br />
                <div className="col-lg-9">
                  <table className="medical-history-table">
                    <tr>
                      <th>
                        Relationship <span className="text-danger">*</span>
                      </th>
                      <th>
                        Disease Name <span className="text-danger">*</span>
                      </th>
                      <th>
                        Approximate Age of Onset{" "}
                        <span className="text-danger">*</span>
                      </th>
                      <th>Genetic Testing Done?</th>
                      <th>Action</th>
                    </tr>
                    {this.state.relationship_list.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <input
                              type="text"
                              value={item.relation}
                              style={{ height: 35 }}
                              onChange={(e) =>
                                this.update_relation(e, item, "relation")
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              value={item.disease}
                              style={{ height: 35 }}
                              onChange={(e) =>
                                this.update_relation(e, item, "disease")
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              value={item.age}
                              style={{ height: 35 }}
                              min={18}
                              max={100}
                              onChange={(e) =>
                                this.update_relation(e, item, "age")
                              }
                            />
                          </td>
                          <td>
                            <select
                              value={item.is_genetic_testing_done}
                              onChange={(e) =>
                                this.update_relation(
                                  e,
                                  item,
                                  "is_genetic_testing_done"
                                )
                              }
                              className="form-control"
                              style={{ width: 67, fontSize: 14 }}
                            >
                              <option value="">Select</option>
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                              <option value="Unsure">Unsure</option>
                            </select>
                          </td>
                          <td>
                            <center>
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => this.remove_relation(item.id)}
                              >
                                <box-icon
                                  size={"20px"}
                                  name="trash"
                                  color="red"
                                ></box-icon>
                              </span>
                            </center>
                          </td>
                        </tr>
                      );
                    })}
                  </table>
                </div>
              </div>
            )}
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(5)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
